import { Table, TableHeader, TableBody, Pagination, Search, useClientTable } from '../../../components/table';
import React, { useState, useEffect } from 'react';
import NoData from '../../../components/common/NoData';
import Loader from '../../../components/common/Loader';
import { Icon } from '@iconify/react';
import { getTraineeAnalytics } from '../../../services/organization/trainees/trainerAnalytics.service';
import { toast } from '../../../components/ui/notify';

function TraineeAnalyticsClassroomTab({ traineeId }) {
  const [loading, setLoading] = useState(false);
  const [classroomData, setClassroomData] = useState([]);
  const table = useClientTable(classroomData, (classroom) => classroom.cls_name || '');

  const fetchClassroomData = async () => {
    try {
      setLoading(true);
      const response = await getTraineeAnalytics({ trainee_id: traineeId });

      if (response.success) {
        setClassroomData(response.data.classrooms || []);
      } else {
        toast.error(response.message || 'Failed to fetch classroom data');
      }
    } catch (error) {
      console.error('Error fetching classroom data:', error);
      toast.error('Something went wrong while fetching classroom data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (traineeId) {
      fetchClassroomData();
    }
  }, [traineeId]);

  if (loading) {
    return (
      <div className="tw-flex tw-justify-center tw-items-center" style={{ minHeight: '200px' }}>
        <Loader />
      </div>
    );
  }

  return (
    <div className="classroom-list">
      <Search value={table.query} onChange={(event) => table.setQuery(event.target.value)} placeholder="Search classrooms..." className="tw-mb-4" />
      <div className="tw-w-full tw-overflow-x-auto tw-rounded-[0.75rem] tw-border-[1px] [--tw-border-opacity:1] tw-border-[rgb(226_232_240_/_var(--tw-border-opacity,_1))] [-webkit-overflow-scrolling:touch] ui-table-scroll">
        <Table className={"[&_.deleted-accounts-actions_.ui-button-sm]:!tw-w-auto [&_.deleted-accounts-actions_.ui-button-sm]:!tw-h-auto [&_.deleted-accounts-actions_.ui-button-sm]:!tw-min-h-[32px] [&_.deleted-accounts-actions_.ui-button-sm]:!tw-p-[0.45rem_1.25rem] [&_.deleted-accounts-actions_.ui-button-sm]:!tw-inline-flex [&_.deleted-accounts-actions_.ui-button-sm]:!tw-items-center [&_.deleted-accounts-actions_.ui-button-sm]:!tw-justify-center [&_.deleted-accounts-actions_.btn-view]:!tw-min-w-[36px] [&_.deleted-accounts-actions_.btn-view]:!tw-p-[0.45rem_0.7rem] [&_.deleted-accounts-actions_.btn-restore]:!tw-min-w-[92px] [&_.deleted-accounts-actions_.btn-restore]:!tw-pl-[1.35rem] [&_.deleted-accounts-actions_.btn-restore]:!tw-pr-[1.35rem] [&_.deleted-accounts-actions_.btn-delete]:!tw-min-w-[92px] [&_.deleted-accounts-actions_.btn-delete]:!tw-pl-[1.35rem] [&_.deleted-accounts-actions_.btn-delete]:!tw-pr-[1.35rem] tw-w-full tw-border-collapse tw-text-left tw-text-[0.875rem] tw-leading-[1.25rem] [&_>_thead]:[--tw-bg-opacity:1] [&_>_thead]:tw-bg-[rgb(248_250_252_/_var(--tw-bg-opacity,_1))] [&_th]:tw-whitespace-nowrap [&_th]:[--tw-border-opacity:1] [&_th]:tw-border-[rgb(226_232_240_/_var(--tw-border-opacity,_1))] [&_th]:tw-pl-4 [&_th]:tw-pr-4 [&_th]:tw-pt-3 [&_th]:tw-pb-3 [&_th]:tw-text-[0.75rem] [&_th]:tw-leading-[1rem] [&_th]:tw-font-semibold [&_th]:[--tw-text-opacity:1] [&_th]:tw-text-[rgb(100_116_139_/_var(--tw-text-opacity,_1))] [&_td]:[--tw-border-opacity:1] [&_td]:tw-border-[rgb(241_245_249_/_var(--tw-border-opacity,_1))] [&_td]:tw-pl-4 [&_td]:tw-pr-4 [&_td]:tw-pt-[0.875rem] [&_td]:tw-pb-[0.875rem] [&_td]:tw-align-middle [&_td]:[--tw-text-opacity:1] [&_td]:tw-text-[rgb(51_65_85_/_var(--tw-text-opacity,_1))] [&_tbody_tr:last-child_td]:tw-border-b-[0px] [&_tbody_tr]:[transition-property:color,_background-color,_border-color,_text-decoration-color,_fill,_stroke] [&_tbody_tr]:[transition-timing-function:cubic-bezier(0.4,_0,_0.2,_1)] [&_tbody_tr]:[transition-duration:150ms] [&_tbody_tr:hover]:[--tw-bg-opacity:1] [&_tbody_tr:hover]:tw-bg-[rgb(248_250_252_/_var(--tw-bg-opacity,_1))] [&_th]:tw-border-[0px] [&_td]:tw-border-[0px] ui-table ui-table-borderless"}>
          <TableHeader>
            <tr>
              <th style={{ backgroundColor: '#f8f9fa', fontWeight: '500' }}>SL No.</th>
              <th style={{ backgroundColor: '#f8f9fa', fontWeight: '500' }}>Classroom Name</th>
              <th style={{ backgroundColor: '#f8f9fa', fontWeight: '500', textAlign: 'center' }}>Total Trainees</th>
            </tr>
          </TableHeader>
          <TableBody>
            {table.visibleRecords.map((classroom, index) => (
              <tr key={classroom.class_id} className="tw-border-b">
                <td className="tw-py-4 tw-align-middle">{(table.page - 1) * table.pageSize + index + 1}</td>
                <td className="tw-py-4 tw-align-middle">
                  <div className="tw-flex tw-items-center">
                    <Icon icon="fluent:people-team-24-regular" className="!tw-text-[var(--secondary-color)] tw-text-slate-500 tw-me-2" width="24" />
                    <span>{classroom.cls_name}</span>
                  </div>
                </td>
                <td className="tw-py-4 tw-align-middle tw-text-center">
                  <span className={"[&.tw-border-black:hover]:tw-bg-[rgba(0,_0,_0,_0.05)] [[data-theme='dark']_&.tw-border-black]:!tw-border-[var(--border-color)] [[data-theme='dark']_&.tw-border-black]:!tw-text-[var(--text-primary)] [[data-theme='dark']_&.tw-border-black:hover]:tw-bg-[var(--bg-tertiary)] !tw-text-[var(--primary-color)] [&.tw-bg-brand-50]:!tw-bg-[#e7f1ff] [&.tw-bg-brand-50]:tw-border-[1px] [&.tw-bg-brand-50]:tw-border-solid [&.tw-bg-brand-50]:tw-border-[#b6d4fe] tw-inline-flex tw-items-center tw-gap-1 tw-rounded-full tw-text-[0.75rem] tw-font-medium tw-leading-[1rem] tw-inline-flex tw-items-center tw-whitespace-nowrap tw-rounded-full tw-border tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-leading-4 tw-capitalize tw-bg-brand-50 tw-border-brand-600 tw-text-brand-600 tw-text-brand-600"}>
                    {classroom.total_trainees} Trainees
                  </span>
                </td>

              </tr>
            ))}
            {table.totalRecords === 0 && <tr><td colSpan="3"><NoData message={classroomData.length ? 'No matching classrooms found' : 'No classrooms found'} /></td></tr>}
          </TableBody>
        </Table>
      </div>
      <Pagination {...table} onPageChange={table.setPage} onPageSizeChange={table.setPageSize} className="tw-p-4" />
    </div>
  );
}

export default TraineeAnalyticsClassroomTab;
